import classNames from 'classnames';
import React from 'react';

import { ITextInputImperativeActions } from '../../../TextInput/TextInput.types';
import { ISearchBoxProps } from '../../SearchBox.types';
import { SearchBoxLayout } from '../searchBoxLayout/SearchBoxLayout';

import style from './SearchBoxForm.scss';

interface SearchBoxFormProps {
  autoFocusInput?: boolean;
  clearButtonLabel: string;
  dataTestId: string;
  expandedDesktopSuggestions?: boolean;
  handleKeyDown: (e: React.KeyboardEvent) => void;
  handleSubmit: React.FormEventHandler<HTMLFormElement>;
  id: string;
  inputRef: React.RefObject<ITextInputImperativeActions>;
  isDisabled: boolean;
  onBlur?: (event: React.FocusEvent<Element>) => void;
  onChange: (event: React.FormEvent<Element>) => void;
  onClear: () => void;
  onClick: React.MouseEventHandler<Element>;
  onDblClick: React.MouseEventHandler<Element>;
  onFocus?: (event: React.FocusEvent<Element>) => void;
  onKeyPress: ISearchBoxProps['onKeyPress'];
  placeholder: string;
  value: string;
}

export const SearchBoxForm: React.FC<SearchBoxFormProps> = props => {
  const {
    autoFocusInput,
    clearButtonLabel,
    dataTestId,
    expandedDesktopSuggestions,
    handleKeyDown,
    handleSubmit,
    id,
    inputRef,
    isDisabled,
    onBlur,
    onChange,
    onClear,
    onClick,
    onDblClick,
    onFocus,
    onKeyPress,
    placeholder,
    value,
  } = props;
  return (
    <form
      className={classNames(
        style.container,
        expandedDesktopSuggestions && style.expanded,
      )}
      data-testid={dataTestId}
      onSubmit={handleSubmit}
      role="search"
      action="#"
      onClick={() => inputRef.current?.focus()}
      onKeyDown={handleKeyDown}
    >
      <SearchBoxLayout
        autoFocusInput={autoFocusInput}
        clearButtonLabel={clearButtonLabel}
        disabled={isDisabled}
        id={id}
        inputRef={inputRef}
        onBlur={onBlur}
        onClear={onClear}
        onClick={onClick}
        onDblClick={onDblClick}
        onFocus={onFocus}
        onInput={onChange}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        searchButtonLabel={placeholder}
        value={value}
      />
    </form>
  );
};
